import classnames from 'classnames';

import { VODCSSModules } from 'shared/utils/wix-connect';

import { GenericButton } from '../button';
import Icon from 'shared/components/icon/icon';
import withTooltip, { adaptShowStatePropsToClassName } from 'shared/components/with-tooltip/with-tooltip';

import styles from './icon.styl';


@VODCSSModules(styles)
export default class IconButton extends React.Component {

  static propTypes = {
    Button: React.PropTypes.func,
    name: React.PropTypes.string,
    size: React.PropTypes.number,
    label: React.PropTypes.any,
    children: React.PropTypes.any,
    className: React.PropTypes.string,
    iconClassName: React.PropTypes.string,
  };

  static defaultProps = {
    Button: GenericButton,
  };

  get label() {
    const { label, children } = this.props;
    const text = _.isUndefined(label) ? children : label;

    if (!text) {
      return null;
    }

    return (
      <span styleName="text">
        {text}
      </span>
    );
  }

  render() {
    const { Button, name, size, iconClassName, className } = this.props;
    const props = _.omit(this.props, 'intl', 'styles', 'settings', ..._.keys(IconButton.propTypes));

    const label = this.label;

    const styleNames = classnames('icon-button', {
      'icon-only': !label,
      generic: Button === GenericButton,
    });

    return (
      <Button {...props}
              styleName={styleNames}
              className={className}>
        <Icon name={name}
              size={size}
              styleName="icon"
              className={iconClassName} />
        {label}
      </Button>
    );
  }
}

export const TooltipIconButton = withTooltip(adaptShowStatePropsToClassName(IconButton));



// WEBPACK FOOTER //
// ./src/shared/components/button/icon/icon.js